import React, { Component } from 'react';

export class Home extends Component {
  static displayName = Home.name;

  render () {
    return (
      <div>
            <h1>Pad / online helper for the awesome Codenames: Duet word game!</h1>
            <p>Work together to give one word hints and guess all the green words while avoiding falling into a trap (black tiles)!</p>

            <p>For best experience be in a voice call together but this is not mandatory to be able to play the online game.</p>

            <p>Offline mode is used together with the Codenames: Duet card stand to replace the physical cards. No need to keep shuffling and placing those cards anymore!</p>

            <p>Now also with online multiplayer!</p>
            <h2>How to play</h2>
            <p>Start a new game and send the join link or code to someone who joins.</p>
            <p>For gameplay instructions buy the actual game to learn the rules</p>

            <h2>Credits</h2>
            <p>Game mechanics from the actual game: Vlaada Chvatil & Scot Eaton</p>
            <p>Programming of this online helper by <a href="https://www.linkedin.com/in/jukkatykkylainen/">Jukka Tykkylainen</a>.</p>
      </div>
    );
  }
}
